export default "__VITE_ASSET__BxjWFxEI__"